import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

var Logo = function Logo(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children;
  return React.createElement(
    'button',
    { onClick: onClick, className: styles.logo, 'data-hook': 'menu-header' },
    children
  );
};

Logo.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default Logo;
//# sourceMappingURL=Header.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/Header.js